import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1, drainPages } from '../apis.js';
const reqPaymentPlans = collectionEngineV1('/payment-plans', true);
export const create = (caseId, newPaymentPlan) => reqPaymentPlans('POST', `/${caseId}`, {
    body: newPaymentPlan,
});
export const patch = (paymentPlanId, change) => reqPaymentPlans('PATCH', `/${paymentPlanId}`, {
    body: change,
});
export const recalculate = (paymentPlanId) => reqPaymentPlans('POST', `/${paymentPlanId}/recalculate`);
export const settle = (paymentPlanEntryId) => reqPaymentPlans('PUT', `/entries/${paymentPlanEntryId}/settle`);
export const deleteCard = (paymentPlanId) => reqPaymentPlans('DELETE', `/${paymentPlanId}/card`);
const PAYMENT_PLANS_PAGE_SIZE = 500;
export const getByCaseId = (caseId, casualConsistency) => drainPages((page) => reqPaymentPlans('GET', `/?${toQuery({
    caseId,
    page,
    pageSize: PAYMENT_PLANS_PAGE_SIZE,
    casualConsistency: casualConsistency ? true : undefined,
})}`), PAYMENT_PLANS_PAGE_SIZE);
export const getLogsByCaseId = (paymentPlanId, casualConsistency) => reqPaymentPlans('GET', `/${paymentPlanId}/logs${casualConsistency ? '?casualConsistency=true' : ''}`);
export const getSigningLink = (paymentPlanId, successURL, failureURL) => reqPaymentPlans('GET', `/${paymentPlanId}/signing-link?successURL=${encodeURIComponent(successURL)}&failureURL=${encodeURIComponent(failureURL)}`);
export const getPSPLink = (paymentPlanId, provider, paymentOptionId, successURL, failureURL, offerBetalingsservice) => reqPaymentPlans('GET', `/${paymentPlanId}/psp-link?successURL=${encodeURIComponent(successURL)}&failureURL=${encodeURIComponent(failureURL)}&provider=${provider}&paymentOptionId=${paymentOptionId}&offerBetalingsservice=${offerBetalingsservice}`);
export const createBSMandate = (paymentPlanId, input) => reqPaymentPlans('POST', `/${paymentPlanId}/bs-mandate`, { body: input });
export const del = (id) => reqPaymentPlans('DELETE', `/${id}`);
export const getInsights = () => reqPaymentPlans('GET', '/insights/totals');
//# sourceMappingURL=payment-plans.js.map